import { Authentication } from '../../../features/login/types/Login'
import { AuthenticationActionTypes, SET_TOKEN } from './types'

const initialState: Authentication = {}

const authenticationReducer = (state: Authentication = initialState, action: AuthenticationActionTypes) => {
  switch (action.type) {
    case SET_TOKEN:
      return { ...state, token: action.payload }
    default:
      return state
  }
}

export default authenticationReducer
